import Input from './Input';
export default Input;



// WEBPACK FOOTER //
// ./src/components/Input/index.js